import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { env } from '@/config/env'
import { homeFooterSx, homeFooterTextSx } from '../styles/homeStyles'

interface HomeFooterProps {
  readonly testId?: string
}

export function HomeFooter({ testId = 'home-footer' }: HomeFooterProps) {
  return (
    <Box component="footer" role="contentinfo" sx={homeFooterSx} data-testid={testId}>
      <Typography component="p" sx={homeFooterTextSx}>
        {env.VITE_COPYRIGHT_TEXT}
      </Typography>
    </Box>
  )
}
